import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';

export const ClientArticleComment = ({ comment }: { comment: string }) => {
  return (
    <Paragraph
      className="bg-tertiary-200"
      whiteSpace="pre-wrap"
      style={{ padding: 16, borderRadius: 8 }}
    >
      <Stack gap="2px">
        <InlineText weight="medium">
          <Trans id="client.articles.after-sales-comments">After sales service comments</Trans>
        </InlineText>
        <span>&rdquo;{comment}&rdquo;</span>
      </Stack>
    </Paragraph>
  );
};
